import { useTranslation } from 'react-i18next';

import { ConfirmActionModal } from '../ConfirmActionModal/ConfirmActionModal';

type ReprocessMessageModalProps = {
  open: boolean;
  setOpen: (open: boolean) => void;
  onConfirm: () => void;
  fetchesLatestSourceData: boolean;
  documentDate: string;
};

export const ReprocessMessageModal = ({
  open,
  setOpen,
  onConfirm,
  fetchesLatestSourceData,
  documentDate,
}: ReprocessMessageModalProps) => {
  const { t } = useTranslation();
  const suffix = fetchesLatestSourceData ? 'latestData' : 'received';

  /**
   * i18n keys
   * t('transactions:show.actionButtons.reprocessConfirmationModal.title.latestData')
   * t('transactions:show.actionButtons.reprocessConfirmationModal.title.received')
   * t('transactions:show.actionButtons.reprocessConfirmationModal.description.latestData')
   * t('transactions:show.actionButtons.reprocessConfirmationModal.description.received', { date })
   */
  return (
    <ConfirmActionModal
      open={open}
      setOpen={setOpen}
      onConfirm={onConfirm}
      title={t(`transactions:show.actionButtons.reprocessConfirmationModal.title.${suffix}`)}
      description={t(`transactions:show.actionButtons.reprocessConfirmationModal.description.${suffix}`, {
        date: documentDate,
      })}
      confirmLabel={t('transactions:show.actionButtons.reprocessConfirmationModal.confirm')}
      analyticsIdPrefix="reprocess_message"
    />
  );
};
